/* eslint-disable */
import axios from '../../../shared/utils/axios-init';

const initialState = {
  loading: true,
  financeData: [],
  cryptoWithdrawDialog: false,
  cryptoWithdrawDialogData: null,
  cryptoReplenishDialog: false,
  cryptoReplenishDialogData: [],
  commissionOutcome: 0,
  commissionIncome: 0,
  transactionResult: null,
  transactionResultOpened: false,
  fiatReplenishDialogData: null,
  fiatWithdrawDialogData: null,
  replenishCurrencyLoading: null,
};

const getters = {
  getLoading: (state) => state.loading,
  getFinanceData: (state) => state.financeData,
  getCryptoWithdrawDialogData: ({ cryptoWithdrawDialogData }) =>
    cryptoWithdrawDialogData,
  cryptoWithdrawDialogState: ({ cryptoWithdrawDialog }) => cryptoWithdrawDialog,
  getCryptoReplenishDialogData: ({ cryptoReplenishDialogData }) =>
    cryptoReplenishDialogData,
  cryptoReplenishDialogState: ({ cryptoReplenishDialog }) =>
    cryptoReplenishDialog,
  getFiatReplenishDialogData: ({ fiatReplenishDialogData }) =>
    fiatReplenishDialogData,
  getFiatWithdrawDialogData: ({ fiatWithdrawDialogData }) =>
    fiatWithdrawDialogData,
  commissionOutcome: ({ commissionOutcome }) => commissionOutcome,
  commissionIncome: ({ commissionIncome }) => commissionIncome,
};

const mutations = {
  setLoading(state, payload) {
    state.loading = payload;
  },
  setComissionOutcome(state, payload) {
    state.commissionOutcome = payload;
  },
  setComissionIncome(state, payload) {
    state.commissionIncome = payload;
  },
  setFinanceData(state, finance) {
    state.financeData = finance;
  },
  toggleCryptoWithdrawDialog(state, dialogState) {
    if (!dialogState) state.cryptoWithdrawDialogData = null;
    state.cryptoWithdrawDialog = dialogState;
  },
  setCryptoWithdrawDialogData(state, payload) {
    state.cryptoWithdrawDialogData = payload;
  },
  toggleCryptoReplenishDialog(state, dialogState) {
    state.cryptoReplenishDialog = dialogState;
  },
  setCryptoReplenishDialogData(state, payload) {
    state.cryptoReplenishDialogData = payload;
  },
  setFiatWithdrawDialogData(state, payload) {
    state.fiatWithdrawDialogData = payload;
  },
  setFiatReplenishDialogData(state, payload) {
    state.fiatReplenishDialogData = payload;
  },
  setTransactionResultOpened(state, payload) {
    state.transactionResultOpened = payload;
  },
  setTransactionResult(state, payload) {
    state.transactionResult = payload;
  },
  setReplenishCurrencyLoading(state, payload) {
    state.replenishCurrencyLoading = payload;
  },
};

const actions = {
  async fetchFinanceData({ commit }) {
    try {
      commit('setLoading', true);

      const token =
        localStorage.getItem('token') || sessionStorage.getItem('token');
      const data = await axios.post('/cabinet/finances', null, {
        headers: { Authorization: `Bearer ${token}` },
      });
      commit('setComissionOutcome', data.data.commission_outcome);
      commit('setComissionIncome', data.data.commission_income);
      commit('setFinanceData', data.data.finances);
    } catch (err) {
      /* eslint-disable */
      console.log(err);
      commit('setFinanceData', []);
    } finally {
      commit('setLoading', false);
    }
  },

  async submitWithDrawForm({ commit }, payload) {
    try {
      const token =
        localStorage.getItem('token') || sessionStorage.getItem('token');
      return await axios.post(
        '/cabinet/withdraw/create',
        {
          ...payload,
        },
        { headers: { Authorization: `Bearer ${token}` } }
      );
    } catch (err) {
      // console.dir(err.response.data);
      return err.response.data;
    }
  },

  async submitReplenishForm({ commit }, payload) {
    try {
      const token =
        localStorage.getItem('token') || sessionStorage.getItem('token');
      return await axios.post(
        '/cabinet/replenish/create',
        {
          ...payload,
        },
        { headers: { Authorization: `Bearer ${token}` } }
      );
    } catch (err) {
      return err.response.data;
    }
  },

  async createReplenishTransaction({ commit }, payload) {
    try {
      const token =
        localStorage.getItem('token') || sessionStorage.getItem('token');
      const { data } = await axios.post('/pay/create', payload, {
        headers: { Authorization: `Bearer ${token}` },
      });

      return { successUrl: data.pay_url };
    } catch (err) {
      const { response } = err;
      return { error: response.data.err };
    }
  },

  async fetchReplenishData({ commit }, currency) {
    try {
      commit('setReplenishCurrencyLoading', currency);

      const token =
        localStorage.getItem('token') || sessionStorage.getItem('token');

      const { data } = await axios.post(
        '/pay/init',
        { currency },
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      );

      if (!data.success) throw new Error(data.err);

      commit('setCryptoReplenishDialogData', data.crypto_pay);
      commit('toggleCryptoReplenishDialog', true);

      return { success: data.success };
    } catch (error) {
      const msg = error.response.data.err || error.message;
      commit('setCryptoReplenishDialogData', []);
      return { error: msg };
    } finally {
      commit('setReplenishCurrencyLoading', null);
    }
  },
};

export default {
  namespaced: true,
  state: initialState,
  getters,
  actions,
  mutations,
};



// WEBPACK FOOTER //
// ./src/modules/Account/modules/finance.js